// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let RelayEnv = require("../../../RelayEnv.bs.js");
let DebounceP = require("../../common/DebounceP.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let ReasonPromise = require("../../ReasonPromise.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AutocompleteV5 = require("../../../v5/autocomplete/AutocompleteV5.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let SelectInputTextSize = require("../../../v5/common/Form/SelectInputTextSize.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let NotificationPreferencesAreasInputV5Query_graphql = require("../../../__generated__/NotificationPreferencesAreasInputV5Query_graphql.bs.js");
let NotificationPreferencesAreasInputV5_result_graphql = require("../../../__generated__/NotificationPreferencesAreasInputV5_result_graphql.bs.js");

let getConnectionNodes = NotificationPreferencesAreasInputV5_result_graphql.Utils.getConnectionNodes;

let areaTypeV5_decode = NotificationPreferencesAreasInputV5_result_graphql.Utils.areaTypeV5_decode;

let convertFragment = NotificationPreferencesAreasInputV5_result_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationPreferencesAreasInputV5_result_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(NotificationPreferencesAreasInputV5_result_graphql.node, convertFragment, fRef);
}

let Fragment_areaTypeV5_fromString = NotificationPreferencesAreasInputV5_result_graphql.Utils.areaTypeV5_fromString;

let Fragment = {
  getConnectionNodes: getConnectionNodes,
  areaTypeV5_decode: areaTypeV5_decode,
  areaTypeV5_fromString: Fragment_areaTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

let convertVariables = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertVariables;

let convertResponse = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationPreferencesAreasInputV5Query_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, NotificationPreferencesAreasInputV5Query_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(NotificationPreferencesAreasInputV5Query_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(NotificationPreferencesAreasInputV5Query_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function getOptionValue(param) {
  return param.id;
}

function getOptionLabel(param) {
  return param.label;
}

let Area = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};

function queryFn(searchTerm) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
    searchTerm: searchTerm
  }, undefined, undefined)), v => {
    if (v.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: {
          NAME: "REJECTED",
          VAL: v._0
        }
      };
    }
    let r = v._0.notificationPreferenceAreasAutocomplete;
    if (r === undefined) {
      return {
        TAG: "Error",
        _0: "EMPTY_RESULT"
      };
    }
    let response = RescriptRelay_Fragment.readInlineData(NotificationPreferencesAreasInputV5_result_graphql.node, convertFragment, r.fragmentRefs);
    let areas = getConnectionNodes(response.areas);
    return {
      TAG: "Ok",
      _0: Stdlib_Array.filterMap(areas, param => {
        let label = param.label;
        let id = param.id;
        return Stdlib_Option.map(Stdlib_Option.flatMap(param.type_, v => areaTypeV5_decode(v)), t => ({
          id: id,
          label: label,
          type_: t
        }));
      })
    };
  });
}

function NotificationPreferencesAreasInputV5(props) {
  let excludeItemFn = props.excludeItemFn;
  let status = props.status;
  let onChange = props.onChange;
  let queryFn$1 = DebounceP.make(300, input => Utils__Promise.toJsPromise(queryFn(input)));
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(AutocompleteV5.AsyncSelect.Single.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      isClearable: true,
      loadOptions: v => {
        let v$1 = Utils.$$String.trimInput(v);
        if (v$1.length < 2) {
          return Promise.resolve([]);
        } else {
          return queryFn$1(Utils.$$String.trimInput(v$1)).then(res => {
            if (excludeItemFn !== undefined) {
              return res.filter(area => excludeItemFn(area));
            } else {
              return res;
            }
          });
        }
      },
      onBlur: props.onBlur,
      onFocus: props.onFocus,
      onChange: value => {
        if (onChange !== undefined) {
          return onChange(value);
        }
      },
      noOptionsMessage: v => v.length < 2 ? "Type at least two characters" : "No areas match \"" + v + "\"",
      placeholder: "Add a county, city, neighborhood, or ZIP",
      status: status !== undefined ? (
          status === "ok" ? "Success" : "Failure"
        ) : "Neutral",
      value: undefined
    }),
    className: SelectInputTextSize.className
  });
}

let make = NotificationPreferencesAreasInputV5;

exports.Fragment = Fragment;
exports.Query = Query;
exports.Area = Area;
exports.queryFn = queryFn;
exports.make = make;
/* use Not a pure module */
